import React from 'react';
import { Box } from '@material-ui/core';

/**
 * Footer Container Component
 */
const Footer = ({ children, padding = 16, style, ...props }) => (
  <Box
    component="footer"
    style={{
      padding: `${padding}px`,
      backgroundColor: '#fafafa',
      borderTop: '1px solid #e0e0e0',
      width: '100%',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      marginTop: 'auto',
      ...style,
    }}
    {...props}
  >
    {children}
  </Box>
);

export default Footer;
